/* OFF BAPOK — collection gallery behaviour: reveal, pointer tilt + glare (eases back on leave), filter chips with re-flowed bento rhythm, lazy slow-mo clips. */
(() => {
  const grid = document.getElementById('ogMosaic');
  if (!grid) return;
  const tiles = [...grid.querySelectorAll('.og-t')];
  /* owner order (2 Oct): Naari Shakti (centred lotus, Sreya) first, other Naari next, the rest keep their order. Re-flow right away. */
  const pri = t => { const h = t.getAttribute('href') || ''; return /naari-shakti/.test(h) ? (/centred/.test(h) ? 0 : 1) : 2; };
  tiles.map((t, i) => [t, i]).sort((a, b) => pri(a[0]) - pri(b[0]) || a[1] - b[1]).forEach(([t], i) => { tiles[i] = t; grid.appendChild(t); });

  /* reveal on scroll */
  const io = new IntersectionObserver(es => es.forEach(x => { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -6% 0px', threshold: .05 });
  tiles.forEach((t, i) => { t.style.transitionDelay = (i % 3) * 70 + 'ms'; io.observe(t); });

  /* Pinterest-moodboard rhythm: pairs of large panes zig-zagging 7/5 then 5/7; a lone trailing item takes the full width.
     Mirrors sections/ob-collection-gallery.liquid's server-rendered pattern (keep both in sync) — this only re-lays-out after a filter changes which tiles are visible. */
  function layout() {
    const vis = tiles.filter(t => !t.hidden);
    vis.forEach((t, i) => {
      const b = Math.floor(i / 2), pos = i % 2, remaining = vis.length - b * 2, zig = b % 2 === 0;
      let span, rows;
      span = 6; rows = 8;   /* equal halves (owner, 2 Oct) */
      t.style.setProperty('--c', span); t.style.setProperty('--r', rows);
    });
  }

  layout();

  /* chips: fit (men/women — unisex tiles always show), or a collection handle via data-cols (home's "Every design" has both) */
  document.querySelectorAll('.og-chip').forEach(b => b.addEventListener('click', () => {
    const k = b.dataset.k;
    document.querySelectorAll('.og-chip').forEach(x => x.setAttribute('aria-pressed', x === b));
    tiles.forEach(t => {
      const fit = t.dataset.fit, cols = (t.dataset.cols || '').split(' ');
      t.hidden = !(k === 'all' || (k === 'men' && (fit === 'men' || fit === 'unisex')) || (k === 'women' && (fit === 'women' || fit === 'unisex')) || cols.includes(k));
      t.classList.add('in');
    });
    layout();
  }));

  /* tilt toward the cursor. Per-pane listeners; the pointer position is measured against the pane's UNTRANSFORMED layout box
     (offsetLeft/Top/Width/Height), so the pane's own rotation can never feed back into the measurement (that feedback made some panes stall). */
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  tiles.forEach(t => {
    let raf = 0;
    t.addEventListener('pointermove', e => {
      if (e.pointerType !== 'mouse') return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        /* absolute layout box of the pane (offset chain, ignores transforms and any positioned ancestor) */
        let ax = 0, ay = 0, n = t; while (n) { ax += n.offsetLeft; ay += n.offsetTop; n = n.offsetParent; }
        const x = clamp((e.pageX - ax) / t.offsetWidth, 0, 1), y = clamp((e.pageY - ay) / t.offsetHeight, 0, 1);
        t.style.setProperty('--tx', ((x - .5) * 2).toFixed(2)); t.style.setProperty('--ty', ((y - .5) * 2).toFixed(2));
        t.style.setProperty('--gx', (x * 100).toFixed(1) + '%'); t.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
    });
    t.addEventListener('pointerleave', () => { cancelAnimationFrame(raf); t.style.setProperty('--tx', 0); t.style.setProperty('--ty', 0); });
  });

  /* phone tilt (gyro): panes lean gently with the phone's orientation, each with a slightly different phase so it feels organic.
     Android starts automatically; iOS needs a one-time tap on the "Enable tilt" pill (Apple requires a user gesture). Off for reduced motion. */
  const coarse = matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (coarse && 'DeviceOrientationEvent' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let tx = 0, ty = 0, gx = 0, gy = 0, on = false, vis = new Set(), loopId = 0, base = null;
    const vio2 = new IntersectionObserver(es => es.forEach(x => x.isIntersecting ? vis.add(x.target) : vis.delete(x.target)), { threshold: .1 });
    tiles.forEach(t => vio2.observe(t));
    const onOrient = e => {
      if (e.gamma == null || e.beta == null) return;
      if (base === null) base = e.beta;                        /* first reading = the way you naturally hold the phone */
      gx = clamp(e.gamma / 14, -1, 1); gy = clamp((e.beta - base) / 14, -1, 1);   /* same +-1 range, reached with a smaller phone movement */
    };
    const frame = () => {
      loopId = 0; if (document.hidden) return;
      tx += (gx - tx) * .13; ty += (gy - ty) * .13;
      vis.forEach(t => {
        const i = tiles.indexOf(t), ph = ((i % 3) - 1) * .18;
        t.style.setProperty('--tx', (tx * (1 + ph)).toFixed(3)); t.style.setProperty('--ty', (ty * (1 - ph)).toFixed(3));
        t.style.setProperty('--gx', (50 + tx * 40).toFixed(1) + '%'); t.style.setProperty('--gy', (40 + ty * 40).toFixed(1) + '%');
      });
      loopId = requestAnimationFrame(frame);
    };
    const start = () => { if (on) return; on = true; addEventListener('deviceorientation', onOrient); if (!loopId) loopId = requestAnimationFrame(frame); };
    document.addEventListener('visibilitychange', () => { if (!document.hidden && on && !loopId) loopId = requestAnimationFrame(frame); });
    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      /* iOS: no visible button. Ask once, silently, on the visitor's first tap/touch anywhere (Apple needs a user gesture); if declined, nothing changes. */
      const ask = () => { removeEventListener('touchend', ask, true); removeEventListener('click', ask, true); DeviceOrientationEvent.requestPermission().then(r => { if (r === 'granted') start(); }).catch(() => {}); };
      addEventListener('touchend', ask, { capture: true, passive: true }); addEventListener('click', ask, true);
    } else start();
  }

  /* slow-mo clips: only for tiles on screen that have data-video, at most 4 playing */
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const vio = new IntersectionObserver(es => es.forEach(x => {
      const t = x.target, src = t.dataset.video; if (!src) return;
      if (x.isIntersecting && !t._v) {
        if (grid.querySelectorAll('video').length >= 4) return;
        const v = document.createElement('video'); v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto'; v.src = src; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        t.insertBefore(v, t.querySelector('img').nextSibling); v.addEventListener('playing', () => v.classList.add('on'), { once: true }); v.play().catch(() => {}); t._v = v;
      } else if (!x.isIntersecting && t._v) { t._v.pause(); t._v.remove(); t._v = null; }
    }), { threshold: .45 });
    tiles.filter(t => t.dataset.video).forEach(t => vio.observe(t));
  }
})();
